var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 5.66946C22.392 5.66946 24 7.00744 24 8.66494V14.6559H19.2V18.6499H4.8V14.6559H0V8.66494C0 7.00744 1.608 5.66946 3.6 5.66946H4.8V0.677002H19.2V5.66946H20.4ZM7.2 2.67399V5.66946H16.8V2.67399H7.2ZM16.8 16.6529V12.6589H7.2V16.6529H16.8ZM19.2 12.6589H21.6V8.66494C21.6 8.11577 21.06 7.66644 20.4 7.66644H3.6C2.94 7.66644 2.4 8.11577 2.4 8.66494V12.6589H4.8V10.6619H19.2V12.6589ZM20.4 9.16418C20.4 9.71335 19.86 10.1627 19.2 10.1627C18.54 10.1627 18 9.71335 18 9.16418C18 8.61501 18.54 8.16569 19.2 8.16569C19.86 8.16569 20.4 8.61501 20.4 9.16418Z",
    fill: "#1E40AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.24c9ec801a22d1d13d05523a2d909a86.svg";
export { ForwardRef as ReactComponent };